<script>
	import { capitalizeEachWord } from "cando-util";
	import { isFormFieldHidden } from "$lib/utilities/isFormFieldHidden.js";

	import Question from "./Question.svelte";
	import MarkedContent from "$lib/components/MarkedContent.svelte";

	export let sections;
	export let responses;
	export let col;
	export let lang;
</script>

<!-- <div class="max-w-[1440px] m-16 w-full p-2 sm:p-4 shadow-xl"> -->
<div class="flex justify-between">
	<MarkedContent
		markedContent={Object.keys(sections).map((s) => sections[s])[0]
			?.translatedSectionObject?.formHeader}
	/>
</div>

{#each Object.entries(sections).filter(([_, section]) => !isFormFieldHidden(section, responses)) as [selectedSection, section]}
	<div
		class="space-y-2 mx-auto w-full my-8 p-2 sm:p-4 bg-base-200 rounded-lg"
	>
		<h2>
			{section.label}
		</h2>
		<div class="grid grid-cols-1 gap-4 sm:grid sm:grid-cols-2 w-full">
			<legend class="sr-only">{capitalizeEachWord(col)} Submission</legend
			>
			{#each section.questions
				.filter((q) => !isFormFieldHidden(q, responses))
				.map( (q) => ({ ...q, readonly: { value: "true" } }), ) as question}
				<Question
					{question}
					response={responses[question.label?.value]}
					responseIsValid={true}
					{lang}
					handleChange={() => {}}
					readonly={true}
				/>
			{/each}
		</div>
	</div>
{/each}
